var exports = {
  "k": "x93eb46d8--39ce65--container",
};

module.exports = exports;
